import React, { useState, useEffect, useContext } from 'react';
import './TopAlarmers.css';
import MonitoredIndividualCarousel from '../MonitoredIndividualCarousel/MonitoredIndividualCarousel';
import formatDuration from '../../common/formatDuration';
import { CardTopAlarmsContext } from '../../contexts/CardTopAlarmsContext';
import logComponent from '../../common/logComponent';


export default function TopAlarmersContent() {
  const cardTopAlarmsContext = useContext(CardTopAlarmsContext);
  const [contentData, setContentData] = useState(null);
  const [visibleAlarmer, setVisibleAlarmer] = useState(null);
  const [monitoredIndividualsAndUnits, setMonitoredIndividualsAndUnits] = useState(null);

  if (logComponent('TopAlarmersContent')) { console.debug('TopAlarmersContent rendered'); }


  useEffect(() => {
    if (logComponent('TopAlarmersContent')) {console.debug('TopAlarmersContent useEffect [cardTopAlarmsContext.topAlarms]'); }
    setContentData(cardTopAlarmsContext.topAlarms ? [...cardTopAlarmsContext.topAlarms] : null);
  }, [cardTopAlarmsContext.topAlarms]);


  useEffect(() => {
    if (logComponent('TopAlarmersContent')) {console.debug('TopAlarmersContent useEffect [cardTopAlarmsContext.topAlarmsMonitoredIndividualsAndUnits]'); }
    setMonitoredIndividualsAndUnits(cardTopAlarmsContext.topAlarmsMonitoredIndividualsAndUnits ? [ ...cardTopAlarmsContext.topAlarmsMonitoredIndividualsAndUnits ] : null);
  }, [cardTopAlarmsContext.topAlarmsMonitoredIndividualsAndUnits]);

  const updateVisibleAlarmer = (alarmer) => {
    if (logComponent('TopAlarmersContent')) {console.debug('TopAlarmersContent updateVisibleAlarmer'); }
    let newVisibleAlarmer;

    if (alarmer.unitId) {
      newVisibleAlarmer = contentData.find(item => item.unit && item.unit.unitId === alarmer.unitId);
    } else if (alarmer.monitoredIndividualId) {
      newVisibleAlarmer = contentData.find(item => item.monitoredIndividual && item.monitoredIndividual.monitoredIndividualId === alarmer.monitoredIndividualId);
    } else {
      return;
    }
    setVisibleAlarmer(newVisibleAlarmer);
  }

  return (contentData &&
    (contentData.length > 0 ?
      <MonitoredIndividualCarousel monitoredIndividuals={monitoredIndividualsAndUnits} onChange={updateVisibleAlarmer}>
        <ul className="Top-Alarmers__alarm-info-list">
          <li key="topTotalAlarms" className="Top-Alarmers__alarm-info-item">
            <p>Total alarms:</p>
            <p>{visibleAlarmer && visibleAlarmer.alarmCount}</p>
          </li>
          <li key="topAverageResponse" className="Top-Alarmers__alarm-info-item">
            <p>Average response time:</p>
            <p>{visibleAlarmer && formatDuration(visibleAlarmer.averageResponseTimeSec, 'hh:mm:ss')}</p>
          </li>
        </ul>
      </MonitoredIndividualCarousel> :
      <p className="Top-Alarmers__empty-message">No alarms reported</p>)
  );
}
